<template>
  <div :is="tag" :class="[getSlideClass, {open: isOpened || isOpen}]"
  @click="toggleDropDown"
  v-click-outside="closeDropDown">
    <slot name="title">
      <a class="dropdown-toggle btn-rotate" data-toggle="dropdown" href="javascript:void(0)">
        <img :src="icon" alt="Icon" class="nav-icon">
        <p v-if="title" class="notification notification--top">{{title}}
        </p>
      </a>
    </slot>
    <ul class="dropdown-menu">
      <slot></slot>
    </ul>
  </div>
</template>
<script>
  export default {
    name: 'drop-down',
    props: {
      title: String,
      icon: String,
      isOpened: {
        type: Boolean,
        default: false
      },
      slide: {
        type: String,
        default: 'down'
      },
      tag: {
        type: String,
        default: 'div'
      }
    },
    computed: {
      getSlideClass () {
        return this.slide === 'down' ? 'dropdown' : 'dropup'
      }
    },
    data () {
      return {
        isOpen: false
      }
    },
    methods: {
      toggleDropDown () {
        this.isOpen = !this.isOpen
      },
      closeDropDown () {
        this.isOpen = false;
      }
    }
  }
</script>

<style lang="scss">
.notification {
  display: inline-block;
  border-radius: 10px;
  padding: 0 6px;
  height: 20px;
  background: #FF3738;
  color: #fff;
  margin-left: 8px;
  font-weight: 500;
  font-size: 12px;
  text-align: center;
  line-height: 20px
}
.notification--top {
  position: absolute;
  left: calc(100% - 11px);
  top: 0px;
}
</style>